module.exports = __webpack_public_path__ + "img/IT_institute_logo@2x.1cefda54.png";